import { AccountPeopleProfile } from 'api/account-people/profile-type';
import { Sections } from '../../content-navigator';
import { GroupedSignalOccurrences } from '../components/grouped-signal-occurrences';

interface Props {
  userProfile: AccountPeopleProfile;
  isFullWidth?: boolean;
}
export const OpportunityLogSection = ({ userProfile, isFullWidth }: Props) => {
  return (
    <GroupedSignalOccurrences
      userProfile={userProfile}
      sectionKey={Sections.OpportunityLog}
      isFullWidth={isFullWidth}
    />
  );
};
